import React from "react";
import __ from "src/utils/Translations";

export const getPositionsImportInstructions = (): React.ReactNode[] => [
  <>
    {__("Pierwszy wiersz pełni funkcję nagłówka, a")}{" "}
    <strong>{__("import danych rozpoczyna się od drugiego wiersza.")}</strong>{" "}
    {__("Zawartość pierwszego wiersza nie jest przetwarzana.")}
  </>,
  <>
    {__("Każdy wiersz w pliku")}{" "}
    <strong>{__("powinien zawierać dokładnie 1 kolumnę.")}</strong>
  </>,
  <>
    <strong>
      {__("Import służy wyłącznie do dodawania nowych stanowisk")}
    </strong>
    {" - "}
    {__("nie można przez niego edytować istniejących wpisów.")}{" "}
    <strong>
      {__("Edycja odbywa się ręcznie przez panel administracyjny.")}
    </strong>
  </>,
  <>
    {__(
      "Stanowiska, których nazwa pokrywa się z już istniejącą pozycją w słowniku (z pominięciem wielkości liter i zbędnych spacji), zostaną pominięte z ostrzeżeniem."
    )}
  </>,
  <>
    <strong>{__("Możesz skorzystać z gotowego szablonu")}</strong>{" "}
    {__("z nazwami kolumn lub wyeksportować aktualną listę stanowisk.")}
  </>,
  <>
    {__("Oczekiwany format plików to")}{" "}
    <strong>{__("CSV UTF-8 rozdzielany średnikami")}</strong>
  </>,
];
